"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _AppActions = require("../actions/AppActions");

var _WorkspaceActions = require("../actions/WorkspaceActions");

var _ModalTypes = _interopRequireDefault(require("../constants/ModalTypes"));

var _handleActions;

var initialState = null;

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _AppActions.AppActionTypes.DISPLAY_MODAL, function (state, action) {
  return action.payload.data;
}), (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_WorkspaceActions.WorkspaceActionTypes.CANCELLED_WORKSPACE_CREATION, _WorkspaceActions.WorkspaceActionTypes.CANCELLED_WORKSPACE_DELETION, _WorkspaceActions.CreateWorkspaceActionTypes.FAILURE, _WorkspaceActions.CreateWorkspaceActionTypes.SUCCESS, _WorkspaceActions.DeleteWorkspaceActionTypes.FAILURE, _WorkspaceActions.DeleteWorkspaceActionTypes.SUCCESS, _WorkspaceActions.WorkspaceActionTypes.CANCELLED_WORKSPACE_MEMBERS_DELETION, _WorkspaceActions.DeleteWorkspaceMembersActionTypes.FAILURE, _WorkspaceActions.DeleteWorkspaceMembersActionTypes.SUCCESS, _WorkspaceActions.WorkspaceActionTypes.CANCELLED_ASSIGN_MEMBERS, _WorkspaceActions.AddWorkspaceMembersActionTypes.FAILURE, _WorkspaceActions.AddWorkspaceMembersActionTypes.SUCCESS, _WorkspaceActions.EditWorkspaceActionTypes.FAILURE, _WorkspaceActions.EditWorkspaceActionTypes.SUCCESS, _WorkspaceActions.WorkspaceActionTypes.CANCELLED_RENAME_WORKSPACE), function () {
  return initialState;
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.STAGE_WORKSPACE, function (state, action) {
  var modalToOpen = action.payload.modalToOpen;
  return modalToOpen || state;
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.CONFIRM_WORKSPACE_DELETION, function () {
  return _ModalTypes.default.DELETE_WORKSPACE_CONFIRMATION_MODAL;
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.CONFIRM_WORKSPACE_MEMBERS_DELETION, function () {
  return _ModalTypes.default.DELETE_WORKSPACE_MEMBERS_CONFIRMATION_MODAL;
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.ASSIGN_WORKSPACE_MEMBERS, function () {
  return _ModalTypes.default.ASSIGN_WORKSPACE_MEMBERS_MODAL;
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.START_RENAME_WORKSPACE, function () {
  return _ModalTypes.default.RENAME_WORKSPACE_MODAL;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;